"use client"

import { ShoppingBag } from "lucide-react"

export const TopProducts = ({ products }) => {
    const hasProducts = Array.isArray(products) && products.length > 0
    const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL || process.env.REACT_APP_BASE_URL

    return (
        <div
            style={{
                width: "100%",
                maxWidth: "100%",
                marginTop: "2rem",
                minHeight: "550px",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <h2
                style={{
                    fontSize: "1.25rem",
                    fontWeight: 600,
                    color: "#1f2937",
                    marginBottom: "1rem",
                    margin: "0 0 1rem 0",
                }}
            >
                Top 5 Products
            </h2>

            {hasProducts ? (
                <div
                    style={{
                        overflowX: "auto",
                        borderRadius: "12px",
                        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                        backgroundColor: "#fff",
                        border: "1px solid #e5e7eb",
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <table
                        style={{
                            width: "100%",
                            fontSize: "0.875rem",
                            textAlign: "left",
                            borderCollapse: "collapse",
                            height: "100%",
                        }}
                    >
                        <thead
                            style={{
                                backgroundColor: "#f8fafc",
                                color: "#374151",
                                fontWeight: 500,
                                borderBottom: "2px solid #e2e8f0",
                            }}
                        >
                            <tr>
                                <th
                                    style={{
                                        padding: "1rem",
                                        fontSize: "0.875rem",
                                        fontWeight: "600",
                                        color: "#374151",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.05em",
                                    }}
                                >
                                    Image
                                </th>
                                <th
                                    style={{
                                        padding: "1rem",
                                        fontSize: "0.875rem",
                                        fontWeight: "600",
                                        color: "#374151",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.05em",
                                    }}
                                >
                                    Product Name
                                </th>
                                <th
                                    style={{
                                        padding: "1rem",
                                        fontSize: "0.875rem",
                                        fontWeight: "600",
                                        color: "#374151",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.05em",
                                    }}
                                >
                                    Arabic Name
                                </th>
                                <th
                                    style={{
                                        padding: "1rem",
                                        textAlign: "right",
                                        fontSize: "0.875rem",
                                        fontWeight: "600",
                                        color: "#374151",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.05em",
                                    }}
                                >
                                    Total Sold
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {products.slice(0, 5).map((product, index) => (
                                <tr
                                    key={product._id}
                                    style={{
                                        borderBottom: index < 4 ? "1px solid #f1f5f9" : "none",
                                        backgroundColor: "#fff",
                                        transition: "all 0.2s ease",
                                        cursor: "pointer",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = "#f8fafc"
                                        e.currentTarget.style.transform = "translateY(-1px)"
                                        e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)"
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = "#fff"
                                        e.currentTarget.style.transform = "translateY(0)"
                                        e.currentTarget.style.boxShadow = "none"
                                    }}
                                >
                                    <td style={{ padding: "1rem" }}>
                                        <div
                                            style={{
                                                width: "64px",
                                                height: "64px",
                                                borderRadius: "8px",
                                                overflow: "hidden",
                                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                                border: "2px solid #f1f5f9",
                                            }}
                                        >
                                            <img
                                                src={FILE_BASE_URL + "/" + product.image || "/placeholder.svg"}
                                                alt={product.name}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                    transition: "transform 0.2s ease",
                                                }}
                                                onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                                                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                                            />
                                        </div>
                                    </td>
                                    <td
                                        style={{
                                            padding: "1rem",
                                            color: "#1f2937",
                                            fontWeight: 600,
                                            lineHeight: "1.5",
                                        }}
                                    >
                                        {product.name}
                                    </td>
                                    <td
                                        style={{
                                            padding: "1rem",
                                            color: "#6b7280",
                                            fontStyle: "italic",
                                        }}
                                    >
                                        {product.nameAr}
                                    </td>
                                    <td
                                        style={{
                                            padding: "1rem",
                                            textAlign: "right",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontWeight: 700,
                                                color: "#1f2937",
                                                fontSize: "1rem",
                                                backgroundColor: "#eff6ff",
                                                padding: "6px 12px",
                                                borderRadius: "8px",
                                                border: "1px solid #dbeafe",
                                            }}
                                        >
                                            {product.totalSold}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div
                    style={{
                        padding: "3rem 2rem",
                        border: "2px dashed #d1d5db",
                        borderRadius: "12px",
                        textAlign: "center",
                        backgroundColor: "#f9fafb",
                        color: "#6b7280",
                        fontSize: "1rem",
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "inset 0 2px 4px rgba(0,0,0,0.06)",
                    }}
                >
                    <div
                        style={{
                            fontSize: "3rem",
                            marginBottom: "1rem",
                            color: "#d1d5db",
                        }}
                    >
                        <ShoppingBag color="#33bdbf" />
                    </div>
                    <div style={{ fontWeight: 600, marginBottom: "0.5rem" }}>No products available</div>
                    <div style={{ fontSize: "0.875rem", color: "#9ca3af" }}>Products will appear here once added</div>
                </div>
            )}
        </div>
    )
}
